import { SetorForm } from '@presentation/components/organisms'
import { EditModal } from '@presentation/components/templates'
import { EditModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  id: string
  onEdit: () => void
}

const EditSetorModal: React.FC<Props> = ({ id, onEdit }) => {
  const modalConfigs: EditModalProps = {
    id,
    path: '/setores',
    formId: 'edit-setor',
    nameForTitle: 'Setor',
    validationSchema,
    mapRequest: data => ({
      ...data,
      lotacao_id: data.lotacao.id,
      local_id: data.local.id
    }),
    onEdit
  }

  return (
    <EditModal {...modalConfigs}>
      <SetorForm />
    </EditModal>
  )
}

export default EditSetorModal
